export const envConfig = {
  cloudflareWorkerConfirmEmail: process.env.NODE_ENV === "development" ?
      "http://127.0.0.1:8787/confirmSub"
      : "https://subs-handling.lnkdr.workers.dev/confirmSub",
}
